const ITEMS = [
  "Birthday Events",
  "Anniversaries",
  "Welcome Baby",
  "Baby Showers",
  "Car Decoration",
  "Romantic Rooms",
  "Return Gifts",
  "Designer Cakes",
];

function Run({ hidden = false }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-serif text-2xl italic tracking-wide text-cream/80 sm:text-3xl">
            {item}
          </span>
          <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 text-gold" fill="currentColor">
            <path d="M12 0l3 12-3 12-3-12z" transform="rotate(90 12 12)" />
            <path d="M12 0l3 12-3 12-3-12z" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="services-marquee" className="relative overflow-hidden border-y border-gold-faint bg-night py-5">
      <div className="flex w-max animate-marquee">
        <Run />
        <Run hidden />
      </div>
    </div>
  );
}
